import { formattedHeaderWithStyles, productInfoHeaderStyles } from '../../common/components/product-information-header'
import BIMESSAGES from '../../../../../data-model/constants/bi-messages'
import values from 'core/data-model/constants/values'

export const render = (displayProduct, redline) => {
  let header1 = displayProduct.name
  let headerTH = displayProduct.nameThai
  if (values.ROKE_RAI_SO_SHIELD_GROUP.includes(displayProduct.code)) {
    header1 = BIMESSAGES.LIFE_READY_PACKAGE_NAME
    headerTH = BIMESSAGES.LIFE_READY_PACKAGE_NAME_THAI
  }
  const header2 = `${headerTH} (${displayProduct.basicPlanCode})`
  return formattedHeaderWithStyles(header1, header2, redline, productInfoHeaderStyles)
}
